import React from 'react';
import Carrier from './Carrier';
import { RouteComponentProps } from '@reach/router';
import { Stack, MenuOverlay } from '@quotient/riq-react-ui';
import { AppContext } from '@quotient/riq-state';

const Page: React.FC<RouteComponentProps> = ({ children }) => {
  const { appState } = React.useContext(AppContext);

  return (
    <Stack css={{ maxWidth: ['none', '1170px'], overflow: 'hidden' }} marginX="auto" direction="vertical">
      <MenuOverlay show={appState.isCarrierMenuOpen} />
      {children}
    </Stack>
  );
};

export default Page;
